// extracted by mini-css-extract-plugin
module.exports = {"container":"landingPage_container__flbt5","image":"landingPage_image__11Kh8","imgBack":"landingPage_imgBack__2TMnG"};